import { h, render } from 'preact';
import { useEffect, useMemo, useState, useCallback } from 'preact/hooks';
import useResponsive from 'utils/responsive';
import ProductGallery from './product-gallery';
import ProductDetail from './product-detail';

const Product = ({ layout, product, ...restProps }) => {
  const { isMobile } = useResponsive();
  const [filteredVariants, setFilteredVariants] = useState([]);
  const [isFiltered, setIsFiltered] = useState(false);

  const filterVariantsBySale = useCallback(
    (variants, isSaleVariant) =>
      variants.filter((variant) => {
        const isSale = variant.saleVariant === true || variant.saleVariant === 'true';
        return isSaleVariant ? isSale : !isSale;
      }),
    [],
  );

  useEffect(() => {
    if (
      !Shopify?.designMode &&
      (product.tags.some((tag) => tag === 'is_custom_product::True') ||
        product.tags.some((tag) => tag === 'is_gan_product::True'))
    ) {
      window.location.href = '/collections/customizer';
    }
  });

  useEffect(() => {
    const params = new URLSearchParams(window.location.search);
    const variantId = params.get('variant');
    const saleView = params.get('sale_value') === 'true';
    if (variantId) {
      const selectedVariant = product.variants.find((v) => v.id.includes(variantId));
      const isSaleVariant = selectedVariant?.saleVariant === true || selectedVariant?.saleVariant === 'true';
      const newVariants = filterVariantsBySale(product.variants, isSaleVariant);
      setFilteredVariants(newVariants.length > 0 ? newVariants : product.variants);
    } else {
      // No variant specified
      const saleVariants = filterVariantsBySale(product.variants, true);
      const nonSaleVariants = filterVariantsBySale(product.variants, false);

      if (saleView && saleVariants.length > 0) {
        setFilteredVariants(saleVariants);
        const firstVariant = saleVariants[0];
        if (firstVariant) {
          setTimeout(() => {
            const variantUpdatedEvent = new CustomEvent('variantUpdate', {
              detail: { currentVariant: firstVariant },
            });
            document.dispatchEvent(variantUpdatedEvent);
          }, 100);
        }
      } else if (nonSaleVariants.length > 0) {
        setFilteredVariants(nonSaleVariants);
        const firstVariant = nonSaleVariants[0];
        if (firstVariant) {
          setTimeout(() => {
            const variantUpdatedEvent = new CustomEvent('variantUpdate', {
              detail: { currentVariant: firstVariant },
            });
            document.dispatchEvent(variantUpdatedEvent);
          }, 100);
        }
      } else {
        setFilteredVariants(saleVariants);
      }
    }

    setIsFiltered(true);
  }, [product.variants, filterVariantsBySale]);

  if (!isFiltered) return null;

  const gallery = useMemo(
    () => (
      <ProductGallery
        filteredVariants={filteredVariants}
        product={product}
        layout={layout}
        {...restProps}
      />
    ),
    [filteredVariants, product, layout, restProps],
  );

  return (
    <div className="container flex flex-col pt-10 md:flex-row md:items-start md:gap-20 md:pt-20 l:gap-40">
      {!isMobile && gallery}
      <ProductDetail
        filteredVariants={filteredVariants}
        product={product}
        layout={layout}
        {...restProps}
      />
    </div>
  );
};

export default (element, data) => {
  render(<Product {...data} />, element);
};
